import { GlobalFilter } from 'pages/components/GlobalFilter'
import { form } from './form'
import { FormFilters } from './interfaces'
import { schema } from './schema'

interface FilterNotifications {
    onSubmit: (filters: FormFilters) => void
}

export const FilterNotifications: React.FC<FilterNotifications> = ({
    onSubmit
}) => {
    return (
        <GlobalFilter
            loadingFilter={false}
            schema={schema}
            form={form}
            title="Filtrar Notificações"
            actionFilter={onSubmit}
        />
    )
}
